module.exports = __webpack_public_path__ + "img/cookie.7757b7b.svg";